import React from 'react'
import './Sidebar.css'
import Logo from '../../assets/logo.png'
import Wallet from '../wallet/Wallet'



const Sidebar = () => {

    

	return (
		<div className="sidebar-ctn">
            <div className="logo-ctn">
                <img src={Logo} alt="Drip" />
            </div>
            <div className="link-ctn">
                <span className="active-nav">Dashboard</span>
                <span>Marketplace</span>
                <span>Settings</span>
            </div>
        <div className="wallet-ctn">
            <Wallet />
        </div>
		</div>
	)
}

export default Sidebar
